import { createSlice } from '@reduxjs/toolkit';

let tempId = 0;

const normalize = (m) =>
  (m?.structured_object && !m.structuredObject)
    ? { ...m, structuredObject: m.structured_object }
    : m;

const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    history: [],
  },
  reducers: {
    addMessage: (state, action) => {
      const payload = normalize(action.payload);
      const backendId = payload.id;
      const existingIndex = backendId ? state.history.findIndex(m => m.id === backendId) : -1;
      if (existingIndex >= 0) {
        state.history[existingIndex] = {
          ...state.history[existingIndex],
          ...payload,
          isNew: true,
        };
        return;
      }
      state.history.push({
        ...payload,
        id: backendId || `temp-${++tempId}`,
        isNew: true,
      });
    },
    setMessages: (state, action) => {
      state.history = action.payload.map((msg) => ({
        ...normalize(msg),
        id: msg.id || `temp-${++tempId}`,
        isNew: false,
      }));
    },
    markMessageSeen: (state, action) => {
      const msg = state.history.find(m => m.id === action.payload);
      if (msg) msg.isNew = false;
    },
    removeMessageById: (state, action) => {
      state.history = state.history.filter(m => m.id !== action.payload);
    },
    removeMessagesByIds: (state, action) => {
      const ids = new Set(action.payload);
      state.history = state.history.filter(m => !ids.has(m.id));
    },
    updateMessage: (state, action) => {
      const { id, ...updates } = action.payload;
      const msg = state.history.find(m => m.id === id);
      if (msg) Object.assign(msg, updates);
    },
  },
});

export const { addMessage, setMessages, markMessageSeen, removeMessageById, removeMessagesByIds, updateMessage } = messagesSlice.actions;
export default messagesSlice.reducer;
